import inMemoryJWT from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";
import Swal from "sweetalert2";
import {
    DELETE_PRODUCT, IS_LOADING_PRODUCTS, LIST_CATEGORY_PRODUCTS, IS_LOADING_LIST_COMPLETE_CATEGORY_PRODUCTS, LIST_COMPLETE_CATEGORY_PRODUCTS, LIST_OF_PRODUCTS,
    CREATE_CATEGORY_PRODUCTS, EDIT_CATEGORY_PRODUCTS, DELETE_CATEGORY_PRODUCTS,
} from "./types";

const toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
});
export const SeeProductsByWinery = (id) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_PRODUCTS
    });
    await fetch(`${urlServer}products/get-products-by-any-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify({ locationID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_OF_PRODUCTS,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })

}
export const SeeCategories = () => async dispatch => {

    await fetch(`${urlServer}adminproductcategories/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_CATEGORY_PRODUCTS,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })

}

export const SeeCompleteCategories = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_LIST_COMPLETE_CATEGORY_PRODUCTS
    });
    await fetch(`${urlServer}adminproductcategories/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_COMPLETE_CATEGORY_PRODUCTS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}
export const deleteProduct = (id) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: IS_LOADING_PRODUCTS
    });
    await fetch(`${urlServer}products/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ productID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_PRODUCT,
                payload: id
            });
        })
}
export const CreateCategoryProduct = (name, clear) => async dispatch => {

    await fetch(`${urlServer}adminproductcategories/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ name })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CREATE_CATEGORY_PRODUCTS,
                    payload: respJson.data
                });
                clear()
            } else {
                toast.fire({
                    icon: "error",
                    text: respJson.error.code ==="ERR032" ? "Ya existe una categoría con el mismo nombre" : "No se pudo crear la categoría"
                })
            }


        })
}

export const EditCategoryProduct = (name, id, clear) => async dispatch => {

    await fetch(`${urlServer}adminproductcategories/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ name, categoryID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_CATEGORY_PRODUCTS,
                    payload: respJson.data
                });
                clear()
            } else {
                toast.fire({
                    icon: "error",
                    text: respJson.error.code ==="ERR032" ? "Ya existe una categoría con el mismo nombre" : "No se pudo editar la categoría"
                })
            }

        })
}
export const deleteCategoryProduct = (id, close) => async dispatch => {

    await fetch(`${urlServer}adminproductcategories/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ categoryID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_CATEGORY_PRODUCTS,
                    payload: id
                });
                close()
            } else {
                toast.fire({
                    icon: "error",
                    text: "No se pudo eliminar la categoría"
                })
            }

        })
}